/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { NumeroSpecialDto } from '../models/numero-special-dto';


/**
 * Fonctions de gestion des numéros spéciaux
 */
@Injectable({
  providedIn: 'root',
})
export class NumerosSpeciauxService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation numeroSpecialGetList
   */
  static readonly NumeroSpecialGetListPath = '/api/numeros-speciaux/list';

  /**
   * Renvoie la liste des numéros spéciaux.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `numeroSpecialGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  numeroSpecialGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<NumeroSpecialDto>>> {

    const rb = new RequestBuilder(this.rootUrl, NumerosSpeciauxService.NumeroSpecialGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<NumeroSpecialDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des numéros spéciaux.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `numeroSpecialGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  numeroSpecialGetList(params?: {
  }): Observable<Array<NumeroSpecialDto>> {

    return this.numeroSpecialGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<NumeroSpecialDto>>) => r.body as Array<NumeroSpecialDto>)
    );
  }

  /**
   * Path part for operation numeroSpecialLoadList
   */
  static readonly NumeroSpecialLoadListPath = '/api/numeros-speciaux/load-list';

  /**
   * Renvoie la liste des numéros spéciaux (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `numeroSpecialLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  numeroSpecialLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, NumerosSpeciauxService.NumeroSpecialLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des numéros spéciaux (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `numeroSpecialLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  numeroSpecialLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.numeroSpecialLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation numeroSpecialGet
   */
  static readonly NumeroSpecialGetPath = '/api/numeros-speciaux/{id}';

  /**
   * Renvoie le numéro spécial spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `numeroSpecialGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  numeroSpecialGet$Response(params: {

    /**
     * Identifiant du numéro spécial
     */
    id: number;
  }): Observable<StrictHttpResponse<NumeroSpecialDto>> {

    const rb = new RequestBuilder(this.rootUrl, NumerosSpeciauxService.NumeroSpecialGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NumeroSpecialDto>;
      })
    );
  }

  /**
   * Renvoie le numéro spécial spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `numeroSpecialGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  numeroSpecialGet(params: {

    /**
     * Identifiant du numéro spécial
     */
    id: number;
  }): Observable<NumeroSpecialDto> {

    return this.numeroSpecialGet$Response(params).pipe(
      map((r: StrictHttpResponse<NumeroSpecialDto>) => r.body as NumeroSpecialDto)
    );
  }

  /**
   * Path part for operation numeroSpecialPut
   */
  static readonly NumeroSpecialPutPath = '/api/numeros-speciaux/{id}';

  /**
   * Met à jour le numéro spécial spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `numeroSpecialPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  numeroSpecialPut$Response(params: {

    /**
     * Identifiant du numéro spécial spécifié à mettre à jour
     */
    id: number;

    /**
     * Numéro spécial
     */
    body: NumeroSpecialDto
  }): Observable<StrictHttpResponse<NumeroSpecialDto>> {

    const rb = new RequestBuilder(this.rootUrl, NumerosSpeciauxService.NumeroSpecialPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NumeroSpecialDto>;
      })
    );
  }

  /**
   * Met à jour le numéro spécial spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `numeroSpecialPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  numeroSpecialPut(params: {

    /**
     * Identifiant du numéro spécial spécifié à mettre à jour
     */
    id: number;

    /**
     * Numéro spécial
     */
    body: NumeroSpecialDto
  }): Observable<NumeroSpecialDto> {

    return this.numeroSpecialPut$Response(params).pipe(
      map((r: StrictHttpResponse<NumeroSpecialDto>) => r.body as NumeroSpecialDto)
    );
  }

  /**
   * Path part for operation numeroSpecialDelete
   */
  static readonly NumeroSpecialDeletePath = '/api/numeros-speciaux/{id}';

  /**
   * Supprime le numéro spécial spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `numeroSpecialDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  numeroSpecialDelete$Response(params: {

    /**
     * Identifiant du numéro spécial à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, NumerosSpeciauxService.NumeroSpecialDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le numéro spécial spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `numeroSpecialDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  numeroSpecialDelete(params: {

    /**
     * Identifiant du numéro spécial à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.numeroSpecialDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation numeroSpecialPost
   */
  static readonly NumeroSpecialPostPath = '/api/numeros-speciaux';

  /**
   * Crée le numéro spécial spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `numeroSpecialPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  numeroSpecialPost$Response(params: {

    /**
     * Numéro spécial
     */
    body: NumeroSpecialDto
  }): Observable<StrictHttpResponse<NumeroSpecialDto>> {

    const rb = new RequestBuilder(this.rootUrl, NumerosSpeciauxService.NumeroSpecialPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NumeroSpecialDto>;
      })
    );
  }

  /**
   * Crée le numéro spécial spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `numeroSpecialPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  numeroSpecialPost(params: {

    /**
     * Numéro spécial
     */
    body: NumeroSpecialDto
  }): Observable<NumeroSpecialDto> {

    return this.numeroSpecialPost$Response(params).pipe(
      map((r: StrictHttpResponse<NumeroSpecialDto>) => r.body as NumeroSpecialDto)
    );
  }

}
